<button 
	class="home-button"
	mat-stroked-button 
	*ngIf="homeRouteIndex >= 0"
	[routerLink]="homeRoute.url"
	>
	<i class="fas fa-home"></i>
	<span>{{homeRoute.name}}</span>
</button>	
